import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

// Initialize Stripe with your publishable key
const stripePromise = loadStripe("pk_live_51RaddFBHTPbIcHwRh9UQA1KKzOEjR3QgRKghaUUAzLfaCAwApVCbKWYWTN4g4BTzzKHHnjzIdHxcl8sq1dJtYHM700vjFk6Iwi");

interface StripeProviderProps {
  children: React.ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;